/**
 * menu redux constants
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// redux action IDs
export const LOAD_MENU                      = 'LOAD_MENU';
export const SELECT_MENU_ITEM               = 'SELECT_MENU_ITEM';
export const SET_FILTER                     = 'SET_FILTER';
export const SET_SUB_FILTERS                = 'SET_SUB_FILTERS';
